"use client";

import { useMemo } from "react";

import { usePreviewModeContext } from "@contexts/preview-mode-context";
import { EventLocationProvider as SharedEventLocationProvider } from "@stadium/services/analytics/context/event-location";
import { useStoreContext } from "@components/store/provider";
import { getBaseEventLocationProperties } from "@helpers/analytics";

export const EventLocationProvider = ({ location, children }) => {
  const { isPricelessShop, isKitShop, storeNumber, isNewSwagmagicHost } = useStoreContext();
  const { previewMode } = usePreviewModeContext();
  const baseEventLocationProperties = useMemo(
    () =>
      getBaseEventLocationProperties({
        previewMode,
        isPricelessShop,
        isKitShop,
        number: storeNumber,
        isLockerShop: isNewSwagmagicHost,
      }),
    [previewMode, isPricelessShop, isKitShop, storeNumber, isNewSwagmagicHost],
  );

  return (
    <SharedEventLocationProvider
      location={location}
      baseEventLocationProperties={baseEventLocationProperties}
    >
      {children}
    </SharedEventLocationProvider>
  );
};
